import React, { createElement } from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogImage?: string;
}
export function SEO({
  title = 'Laravel Recruitment Tests | Evaluate Developer Skills Fast',
  description = 'How do you test Laravel developers before hiring? Use standardized, proctored recruitment tests built by the Certification for Laravel community. From $11 per test.',
  canonical = 'https://recruitmenttest.certificationforlaravel.com',
  ogImage = 'https://cdn.magicpatterns.com/uploads/e5BUmyxLnn3e5mAPwSBoue/Recruitmenttest_logo_website.png'
}: SEOProps) {
  return <Helmet data-id="element-351">
      {/* Google Tag Manager */}
      <script data-id="element-352">
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PTPFTZ9Z');`}
      </script>
      {/* Primary Meta Tags */}
      <title data-id="element-353">{title}</title>
      <meta name="title" content={title} data-id="element-354" />
      <meta name="description" content={description} data-id="element-355" />
      {/* Canonical URL */}
      <link rel="canonical" href={canonical} data-id="element-356" />
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" data-id="element-357" />
      <meta property="og:url" content={canonical} data-id="element-358" />
      <meta property="og:title" content={title} data-id="element-359" />
      <meta property="og:description" content={description} data-id="element-360" />
      <meta property="og:image" content={ogImage} data-id="element-361" />
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" data-id="element-362" />
      <meta property="twitter:url" content={canonical} data-id="element-363" />
      <meta property="twitter:title" content={title} data-id="element-364" />
      <meta property="twitter:description" content={description} data-id="element-365" />
      <meta property="twitter:image" content={ogImage} data-id="element-366" />
      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow" data-id="element-367" />
      <meta name="language" content="English" data-id="element-368" />
      <meta name="viewport" content="width=device-width, initial-scale=1" data-id="element-369" />
      {/* Entity optimization keywords */}
      <meta name="keywords" content="Laravel recruitment test, Laravel developer assessment, hire Laravel developers, Laravel skills evaluation, Laravel talent acquisition, PHP developer screening, Laravel coding test, developer hiring workflow" data-id="element-370" />
    </Helmet>;
}